/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Parq_LongInputs */

const en_us2_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two or more yes answers mean a gentler start and a recommendation to get cleared. Never a block.`)
};

const pt_br2_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas ou mais respostas sim significam começo mais leve e recomendação de liberação. Nunca um bloqueio.`)
};

const es_419_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos o más respuestas afirmativas significan un inicio más suave y la recomendación de obtener autorización médica. Nunca un bloqueo.`)
};

const pt_pt2_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas ou mais respostas sim significam um começo mais leve e a recomendação de pedires autorização médica. Nunca um bloqueio.`)
};

const fr_fr2_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux « oui » ou plus signifient un départ plus doux et le conseil d'obtenir un avis médical. Jamais un blocage.`)
};

const de_de2_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei oder mehr Ja-Antworten bedeuten einen sanfteren Start und die Empfehlung, dich ärztlich durchchecken zu lassen. Nie eine Sperre.`)
};

const it_it2_intake_why_parq_long = /** @type {(inputs: Intake_Why_Parq_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due o più risposte sì significano un inizio più graduale e il consiglio di farti visitare. Mai un blocco.`)
};

/**
* | output |
* | --- |
* | "Two or more yes answers mean a gentler start and a recommendation to get cleared. Never a block." |
*
* @param {Intake_Why_Parq_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_parq_long = /** @type {((inputs?: Intake_Why_Parq_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Parq_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_parq_long(inputs)
	if (locale === "es-419") return es_419_intake_why_parq_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_parq_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_parq_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_parq_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_parq_long(inputs)
	return en_us2_intake_why_parq_long(inputs)
});
export { intake_why_parq_long as "intake.why.parq.long" }